import { Route, Switch } from '@treams/treams-routes';
import { EmployeesContainerWithoutSidebar } from 'packages/kakapo-ui-application/pages/employees/EmployeesContainer';
import CreateEmployee from './CreateEmployee';
import EmployeeSettings from './EmployeeSettings';

export default function EmployeesSettings() {
	return (
		<Switch>
			<Route path="/settings/employees/new">{() => <CreateEmployee />}</Route>
			<Route<{ id: string }> path="/settings/employees/:id">
				{({ match }) => <EmployeeSettings key={match!.params.id} id={match!.params.id!} />}
			</Route>
			<Route path="/settings/employees">{() => <EmployeesContainerWithoutSidebar />}</Route>
		</Switch>
	);
}
